export default __webpack_public_path__ + "static/media/speciality_id_3.3491544b.png";